import React from 'react';
import { Button, Icon, Text } from '@perch-labs/shrike';
import { copyFor } from 'config';
import { Container } from 'styles';
import { DifferentUsernameAccordion } from 'pages/settings/components/different-username-accordion';
import {
  CopyComponent,
  StyledCopyButton,
} from './add-online-utility-account.style';

const getCopy = copyFor('settings.moving.addOnlineAccount');
export interface Props {
  context: MovingStateMachineContext;
  next: (...args: any[]) => any;
}
export const AddOnlineUtilityAccount = ({ context, next }: Props) => {
  const {
    displayName: utilityName,
    url,
    overrideEmailIsUsername,
  } = context.utility;
  const username = context.selectedUtilityAccount?.utilityCredential.username;

  return (
    <div>
      <Text textStyle="heading800" tag="h1">
        {getCopy('title', { utilityName })}
      </Text>
      <Text margin={{ top: '16px' }}>{getCopy('bodyText')}</Text>
      {!!username && (
        <>
          <Text
            tag="h2"
            textStyle="heading500"
            margin={{ bottom: '8px', top: '40px' }}
          >
            {getCopy('copyHeader')}
          </Text>
          <CopyComponent>
            <Text margin={{ right: '16px' }}>{username}</Text>
            <StyledCopyButton copyText={username} />
          </CopyComponent>
        </>
      )}
      <Container flex direction="column" alignItems="center">
        <Button
          margin={{ top: '40px' }}
          onClick={() => window.open(url)}
          fullWidth
        >
          <Icon
            icon="ExternalLink"
            margin={{ right: '8px' }}
            color="primaryInverse"
          />
          {getCopy('link', { utilityName })}
        </Button>
        <Button
          backgroundless={true}
          fullWidth={true}
          margin={{ top: '16px' }}
          onClick={() => next()}
        >
          {getCopy('laterButton')}
        </Button>
      </Container>
      {overrideEmailIsUsername && <DifferentUsernameAccordion />}
    </div>
  );
};
